var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19922 1.37988L15.6956 7.17653L18.896 5.79664L6.45053 0L3.19922 1.37988Z",
    fill: "#DEFFFF",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6953 7.15918L18.8957 5.7793V8.86707L15.6953 10.247V7.15918Z",
    fill: "#DEFFFF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19922 1.38574V4.50179L11.8505 8.52268L3.19922 12.6284V15.7049L15.6956 21.4902V18.3968L7.20822 14.4437L15.6956 10.2645V7.17673L3.19922 1.38574Z",
    fill: "#DEFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6953 21.4674L18.8957 20.0875V10.4453L15.6953 11.8422V21.4674Z",
    fill: "#DEFFFF",
    fillOpacity: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZilIcon);
export default __webpack_public_path__ + "static/media/zil-icon.5e0a47da.svg";
export { ForwardRef as ReactComponent };